import React from "react";
import { Steps } from "antd";
export default function CandidateInterviewHistory() {
  return (
    <>
      <div className="candidate-interview-history-wrapper">
        <h5>Candidate Interview History</h5>
        <Steps
          progressDot
          current={2}
          direction="vertical"
          items={[
            {
              title: "Level 0",
              description: "L0 interview cleared ",
            },
            {
              title: "Level 1",
              description: "L1 interview cleared",
            },
            {
              title: "In Progress",
              description: "This is a description. This is a description.",
            },
            {
              title: "Waiting",
              description: "This is a description.",
            },
            {
              title: "Waiting",
              description: "This is a description.",
            },
          ]}
        />
      </div>
    </>
  );
}
